import { Injectable } from '@angular/core';
import { VantageShellService } from '../vantage-shell/vantage-shell.service';
import { MetricEventName as EventName } from './metrics.enum';
import { AppActivation } from 'src/app/services/metrics/metrics.model';
import { HypothesisService } from 'src/app/services/hypothesis/hypothesis.service';
import { MetricHelper } from './metrics.helper';
import { CommonService } from '../common/common.service';

@Injectable({
	providedIn: 'root'
})
export class MetricsService {
	private metricsClient: any;

	constructor(
		private shellService: VantageShellService,
		hypothesisService: HypothesisService,
		commonService: CommonService
	) {
		this.metricsClient = this.shellService.getMetrics();
		if (this.metricsClient) {
			MetricHelper.initializeMetricClient(this.metricsClient, shellService, commonService, hypothesisService);
			this.metricsClient.metricsEnabled = true;
		}
	}

	public sendAppActivationEvent() {
		const appActivation: AppActivation = {
			ItemType: EventName.appactivation,
		};

		// metrics is alway enabled for Commercal Vantage at present
		this.metricsClient.sendAsync(appActivation);
	}
}
